'use client'
import {
  AlignJustifyIcon,
  // Bell,
  Bookmark,
  CircleUser,
} from 'lucide-react'
import { ContesterLogo } from '@/components/icons'
import { SidebarContentTrigger } from '@/components/ui/sidebar'
import Link from 'next/link'
import { useAuth } from '@/services/providers/auth-provider'
import { usePathname } from 'next/navigation' // Add this import
import { SignInButton } from '@/components/layout/signin/signin-dialog'

const navigationItems = [
  { name: 'งานแข่ง', href: '/' },
  // { name: 'Blog', href: '/blog' },
  { name: 'เกี่ยวกับ', href: '/about' },
  { name: 'ติดต่อ', href: '/contact' },
]

export function NavBar() {
  const auth = useAuth()
  const pathname = usePathname() // Get the current path

  // Check if the current path includes "/apply"
  const isApplicationPage = pathname?.includes('/apply')

  return (
    <nav className="font-darkgrotesque sticky top-0 z-50 flex h-[76px] w-full items-center justify-between bg-white px-6 py-[8px] text-base font-bold text-black md:px-[80px]">
      <div className="my-[10.5px] hidden items-center gap-8 md:flex">
        {navigationItems.map((item, index) => (
          <Link
            key={item.name}
            href={item.href}
            className={`${
              index === 0 ? 'text-zinc-950' : 'text-black'
            } hover:text-zinc-950`}
          >
            {item.name}
          </Link>
        ))}
      </div>

      {/* Only render the burger menu if NOT on application page */}
      {!isApplicationPage && (
        <div className="md:hidden">
          <SidebarContentTrigger contentType="navbar" className="mr-4">
            <AlignJustifyIcon />
          </SidebarContentTrigger>
        </div>
      )}

      <div className="absolute left-1/2 -translate-x-1/2 transform">
        {/* <Switch left="TH" right="ENG" /> */}
        <Link href="/">
          <ContesterLogo />
        </Link>
      </div>

      <div className="my-[15.5px] flex items-center gap-5">
        {/* <Switch left="TH" right="ENG" className="hidden md:flex" /> */}

        {auth.isAuthenticated() && (
          <>
            {/* <SidebarContentTrigger contentType="notification">
              <Bell />
            </SidebarContentTrigger> */}
            <SidebarContentTrigger contentType="save">
              <Bookmark className="h-6 w-6" />
            </SidebarContentTrigger>
            <div className="hidden md:flex">
              <SidebarContentTrigger contentType="profile">
                <CircleUser className="h-6 w-6" />
              </SidebarContentTrigger>
            </div>
          </>
        )}
        <div className="hidden md:block">
          <SignInButton />
        </div>
      </div>
    </nav>
  )
}
